export default "__VITE_ASSET__CV8Z0aS4__"